// extracted by mini-css-extract-plugin
export default {"About7Primary":"About7_About7Primary__Msg8C","About7Main":"About7_About7Main__zKY-n","About7MainParent":"About7_About7MainParent__0+Uvm","About7Parent":"About7_About7Parent__fGSNa"};